
import React from 'react'
import { Input, Table, Typography } from 'antd';
import { useCorreosEnviados } from '../../hooks/adminexamen/useCorreosEnviados';
import { EmptyPersonalizado } from '../../components/EmptyPersonalizado';
import { SearchOutlined } from '@ant-design/icons';

export const CorreosEnviados = () => {

    const { columns, datosAspirantes, loading, setTextoBuscar, textoBuscar } = useCorreosEnviados()

    // var cantidad_aspirantes = buscar_cantidad_aspirantes( datosAspirantes, false );

    return (
        <div style={{
            overflowX: 'scroll'
        }}>

            <Typography.Title level={3}>Correos enviados a aspirantes</Typography.Title>

            <Table
                columns = { columns }
                dataSource = { datosAspirantes }
                loading = { loading }
                rowKey = "pk_envio_correos"
                showSorterTooltip = { false }
                locale = {{ emptyText: <EmptyPersonalizado/> }}
                title = { () => (
                    <>
                      <h1>{ datosAspirantes.length } { (datosAspirantes.length === 1) ? 'correo enviado' : 'correos enviados' } </h1>
                      <Input size='large' id='inputBuscarAspirante' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
                    </>
                )}
            />
        </div>
    )
}
